var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Button from "@atlaskit/button";
import Portal from "@atlaskit/portal";
import Select from "@atlaskit/select";
import { gridSize } from "@atlaskit/theme";
import compact from "lodash/compact";
import * as qs from "querystring";
import * as React from "react";
import styled from "styled-components";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: ", "px;\n  margin-top: ", "px;\n"], ["\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: ", "px;\n  margin-top: ", "px;\n"])), gridSize(), gridSize());
export var ViewLogs = function (_a) {
    var environments = _a.environments, serviceName = _a.serviceName, source = _a.source;
    var formId = "view-logs_" + serviceName;
    var isMicros = source === "micros";
    var envOptions = React.useMemo(function () { return environments.map(function (env) { return ({ label: env.id, value: env.id }); }); }, [environments]);
    var _b = React.useState(null), selectedEnv = _b[0], setSelectedEnv = _b[1];
    var onChangeEnv = React.useCallback(function (value) { return setSelectedEnv(value); }, []);
    var onSubmit = React.useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var url = splunkSearchURL(source, serviceName, selectedEnv ? selectedEnv.value : null);
        window.open(url, "_blank", "noopener,noreferrer");
    }, [serviceName, source, selectedEnv]);
    if (!isMicros) {
        return (React.createElement(Container, null,
            React.createElement(Portal, null,
                React.createElement("form", { id: formId, onSubmit: onSubmit })),
            React.createElement(Button, { type: "submit", form: formId, appearance: "primary", style: { maxWidth: "50%" } }, "View logs in Splunk")));
    }
    return (React.createElement(Container, null,
        React.createElement(Portal, null,
            React.createElement("form", { id: formId, onSubmit: onSubmit })),
        React.createElement(Select, { maxMenuHeight: 200, value: selectedEnv, onChange: onChangeEnv, options: envOptions, placeholder: "Choose an environment", form: formId }),
        React.createElement(Button, { type: "submit", form: formId, appearance: "primary" }, "View logs in Splunk")));
};
export function splunkSearchURL(source, serviceName, environment) {
    var isMicros = source === "micros";
    return "https://splunk.paas-inf.net/en-US/app/search/search?" + qs.stringify({
        q: compact([
            isMicros && "m.t=application",
            "`" + source + "_" + serviceName + "`",
            environment && "env=" + environment,
        ]).join(" "),
        earliest: "-15m",
        latest: "now",
    });
}
var templateObject_1;
